<template>
    <form @submit.prevent="subscribe()">
        <input
            type="text"
            :placeholder="i18n.newsletter_email_placeholder"
            class="footer-newsletter-input"
            v-model="email"
        >
        <select v-model="type" class="footer-newsletter-input footer-newsletter-select">
            <option value="2">{{i18n.newsletter_option_under_6}}</option>
            <option value="1">{{i18n.newsletter_option_above_6}}</option>
            <option value="3">{{ i18n.newsletter_option_all }}</option>
        </select>
        <label class="footer-newsletter-checkbox">
            <input type="checkbox" v-model="gdpr"> <span v-html="i18n.newsletter_gdpr"></span>
        </label>
        <div class="has-text-right">
            <button class="button footer-newsletter-button" type="submit">
	            {{ i18n.newsletter_cta }}
                <span class="material-icons rotating" v-if="loading">hourglass_bottom</span>
            </button>
        </div>
        <p class="footer-newsletter-message">{{ message }}</p>
    </form>
</template>

<script>
    export default {
        props: {},
        data: function () {
            return {
                email: null,
                type: 3,
                message: null,
                gdpr: false,
                loading: false,
	            i18n: i18n
            };
        },
        methods: {
            subscribe: function () {
                if (!this.loading) {
                    this.loading = true;
                    this.message = null;

                    axios
                        .post("/newsletter", {
                            email: this.email,
                            gdpr: this.gdpr,
                            type: this.type
                        })
                        .then(response => {
                            this.message = this.i18n.newsletter_success;
                            this.email = null;
                            this.type = 3;
                            this.gdpr = false;
                        })
                        .catch(error => {
                            this.message = this.i18n.newsletter_error;
                        }).then(() => {
                        this.loading = false;
                    });
                }
            }
        }
    };
</script>
